import React from 'react'

export const addSpanToWhitespace = (text: string): React.ReactNode[] | null => {
  if (!text || typeof text !== 'string') {
    return null
  }
  return [...text].map(char => {
    if (char === ' ') {
      return <span className="highlight">{char}</span>
    } else {
      return char
    }
  })
}
